__turbopack_context__.v({
  "block": "InvestorProfileView-module-scss-module__pA5TmW__block",
  "blockTitle": "InvestorProfileView-module-scss-module__pA5TmW__blockTitle",
  "content": "InvestorProfileView-module-scss-module__pA5TmW__content",
  "missingData": "InvestorProfileView-module-scss-module__pA5TmW__missingData",
  "root": "InvestorProfileView-module-scss-module__pA5TmW__root",
});
